import { render, staticRenderFns } from "./ContentTypeMerchGallery.vue?vue&type=template&id=3dbe6e3b&scoped=true&"
import script from "./ContentTypeMerchGallery.vue?vue&type=script&lang=js&"
export * from "./ContentTypeMerchGallery.vue?vue&type=script&lang=js&"
import style0 from "./ContentTypeMerchGallery.vue?vue&type=style&index=0&id=3dbe6e3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbe6e3b",
  null
  
)

export default component.exports